import React, { Component } from 'react';
import * as securityPost from './SecurityPost';
import PlayerStream from './PlayerStream';
import { API_HOST } from './constants';

class PlayerChannel extends Component {
    constructor(props) {
        super(props);
        this.player = React.createRef(PlayerStream);
        this.state = { selectChannel: [], data: [], isLogin: false };
        this.selectchannel = this.selectchannel.bind(this);

        this.defaultchannel = [];
        let reqProvider = { channel: `ALL Channel` };
        securityPost.Encrypt(reqProvider).then((resolve, rejects) => {
            fetch(`${API_HOST}/stream/channel`, resolve)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    else {
                        throw new Error(`${response.status}-${response.statusText}`);
                    }
                }).then(response => {
                    let def = response.filter(e => e.channel == 'true4u');
                    this.defaultchannel = def[0];
                    this.setState({ data: response });
                    this.parachannel(response);
                }).catch(err => {
                    console.log(err);
                })
        });
    };

    componentWillReceiveProps(nextProps, nextState) {
        if (this.state.isLogin !== nextProps.isLogin) {
            this.state.isLogin = nextProps.isLogin;
            //this.parachannel(this.state.data);
        }   
    }


    componentWillUpdate(nextProps, nextState) {
        const { isLogin } = nextState;
        if (this.state.isLogin !== isLogin) {
            this.state.isLogin = isLogin;
        }        
    }

    componentDidUpdate(){
        if(this.state.isLogin){
            this.parachannel(this.state.data);
        }
    }

    isMemberchannel(isMember) {
        let display = "";
        if (isMember) {
            display = <span className="movies-lock lock">
                <i className="fa fa-lock" aria-hidden="true"></i>
            </span>
        }
        return display;
    }

    selectchannel(e, item) {
        e.preventDefault();
        if (item.isRedirectToPage) {
            window.location = item.page;
        }
        else {
            this.player.current.getUrlStream(item);
        }
    }

    parachannel(data) {
        if (this.player.current !== null) {
            if (this.props.match.params.channel) {
                let item = data.filter(e => e.channel == this.props.match.params.channel);
                if (item.length > 0) {
                    this.player.current.getUrlStream(item[0])
                }
                else {
                    this.player.current.getUrlStream(this.defaultchannel)
                }

            } else {
                this.player.current.getUrlStream(this.defaultchannel)
            }
        }

    }

    displaychannel() {
        let display = "";
        if (this.state.isLogin) {
            display = this.state.data
                .filter(e => e.isShow === true)
                .map((item, index) => {
                    return <div key={index} className="col-4 col-lg thumbnail card rounded-0">
                        <a href="javascript:void(0);" onClick={(e) => this.selectchannel(e, item)}>
                            <figure className="thumbnail-img">
                                <img className="card-img-top img-fluid" src={item.img} alt={item.channelname} />
                                {this.isMemberchannel(item.isMember)}
                            </figure>
                            <div className="card-block">
                                <h3 className="card-text">{item.channelname}</h3>
                            </div>
                        </a>
                    </div>
                });
        } else {
            display = this.state.data
                .filter(e => e.isShow === true)
                .map((item, index) => {
                    return <div key={index} className="col-4 col-lg thumbnail card rounded-0">
                        <a href="javascript:void(0);">
                            <figure className="thumbnail-img">
                                <img className="card-img-top img-fluid" src={item.img} alt={item.channelname} />
                                {this.isMemberchannel(item.isMember)}
                            </figure>
                            <div className="card-block">
                                <h3 className="card-text">{item.channelname}</h3>
                            </div>
                        </a>
                    </div>
                });
        }
        return display;
    }

    displayPlayer() {
        let player = "";
        if (this.state.isLogin) {
            player = <PlayerStream ref={this.player} defaultchannel={this.defaultchannel} />
        } else {
            player = <div id="noLoginPlayer"><div className="login_label">
                กรุณา <a onClick={(e) => this.props.trueMainNav.current.checkTrueIDLoginOpenWidget(e)} href="javascript:void(0);" className="link-to-login"><strong>เข้าสู่ระบบ</strong></a> ก่อนรับชม
                    </div>
                <div className="embed-responsive embed-responsive-16by9">
                    <video poster="" playsInline id="ptvplayer" className="video-js vjs-16-9 vjs-default-skin embed-responsive-item" controls autoPlay width="100%" height="100%" >
                    </video>
                </div>
            </div>
        }
        return player;
    }

    render() {
        return (
            <div>
                <section id="Clip-section" className="content-row py-4">
                    <div className="container normal-article">
                        <h2 className="section-title d-flex">
                            <span className="text-white">ช่องถ่ายทอดสด</span>
                        </h2>
                        <div className="row row-small-gutter list-unstyled mb-0 justify-content-center">
                            {this.displayPlayer()}
                        </div>
                    </div>
                </section>
                <section className="livepremium-content sport-livepremium container my-3">
                    <div className="live-channel row row-small-gutter justify-content-center">
                        {this.displaychannel()}
                    </div>
                </section>
            </div>
        );
    };
};

export default PlayerChannel;


// WEBPACK FOOTER //
// ./src/PlayerChannel.js